export default __webpack_public_path__ + "static/media/e-commerce.65de2f5b.png";